module.exports = __webpack_public_path__ + "wechat-static/img/ecms.ce6c18a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecms.png
// module id = yLZD
// module chunks = 1